import { axios } from '@/utils/request'
import { filterData } from '@/utils/util'

const api = {
  auditAction: `/audit/action`,
  audioRecognize: `/audit/audioRecognize`,
  supporterInfo: `/audit/supporterInfo`,
  list: `/audit/list`,
  auditDetail: `/audit/detail`,
  historyexport: `/audit/historyexport`,
  getCount: `/audit/count`,
  getLabelList: `/audit/labellist`,
  getJobStatus: '/job/getStatus',
  getRefuseList:'/ircs/sysDataSet/list',
}
// 转文字
export function audioRecognize (params) {
  return axios({
    url: api.audioRecognize,
    method: 'post',
    params,
    func:'转文字'
  })
}
// 查询用户信息
export function getCustomerByUid (params) {
  return axios({
    url: api.supporterInfo,
    method: 'get',
    params,
    func:'查询用户信息'
  })
}

// 初审 复审 历史接口
export function getReviewList (data) {
  return axios({
    url: api.list,
    method: 'post',
    data: filterData(data),
    headers: {
      'Content-Type': 'application/json'
    },
    isJson: 1,
    func:'查询初审/复审/历史消息列表'
  })
}

// 审核操作
export function auditAction (data) {
  return axios({
    url: api.auditAction,
    method: 'post',
    data: filterData(data),
    func:'通过/拒绝/拉黑'
  })
}

// 审核详情
export function auditDetail (params) {
  return axios({
    url: api.auditDetail,
    method: 'get',
    params: filterData(params),
    func:'查看详情'
  })
}
// 查询审核数量
export function getCount (params) {
  return axios({
    url: api.getCount,
    method: 'get',
    params: filterData(params),
    func:'查询审核数量'
  })
}
// 查询消息来源列表
export function getLabelList (params) {
  return axios({
    url: api.getLabelList,
    method: 'get',
    params: filterData(params),
    func:'查询消息来源列表',
  })
}
// 导出文件
export function historyexport (params) {
  return axios({
    url: api.historyexport,
    method: 'get',
    params:filterData(params),
    func:'导出'
  })
}
// 导出状态查询
export function getJobStatus (params) {
  return axios({
    url: api.getJobStatus,
    method: 'get',
    params: filterData(params),
    func:'查询导出状态'
  })
}
// 查询拒绝原因列表
export function getRefuseList (params) {
  return axios({
    url: api.getRefuseList,
    method: 'get',
    params: filterData(params),
    func:'查询拒绝原因列表'
  })
}
